import Vue from 'vue'
import store from '@/store/store'

function canFunc(el, value, arg, vnode) {
    let permissionName
    let permissionType

    if (value) {
        permissionName = value.split('.')[0]
        permissionType = value.split('.')[1]
    } else {
        permissionName = permissionType = undefined
    }

    global.vm.$nextTick(() => {
        let permission
        const name = store.state.userPermissions[permissionName]

        if (permissionName && permissionType && name) {
            permission = name.includes(permissionType)

            if (permission && arg === 'show') {
                vnode.elm.parentNode.removeChild(el)
            } else if (!permission && arg !== 'show') {
                vnode.elm.parentNode.removeChild(el)
            }
        } else {
            vnode.elm.parentNode.removeChild(el)
        }
    })
}

export default Vue.directive('can', {
    bind (el, binding, vnode) {
        canFunc(el, binding.value, binding.arg, vnode)
    }
})
